import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { colors } from 'syf-component-library/defaultTheme';
import { Trans, useTranslation } from 'react-i18next';
import { FAL_CHECK, FAR_CIRCLE_EXCLAMATION, Icon } from '@account-services-mfe/core';
import { AgreementContainer, ErrorMessageText, ErrorWrapper, AgreementCheckbox as StyledCheckbox, TermsContainer } from './subcomponents';
import { usePaymentSecurityContext } from '../../../context';
import triggerPaymentSecurityAnalytics from '../../../helpers/trigger-payment-security-analytics';
import { PAGE_NAME } from '../../../const/analytics';
const AgreementCheckbox = () => {
    const { t } = useTranslation();
    const { isChecked, updateCheckboxValue, clearError, hasErrorOnSubmit } = usePaymentSecurityContext();
    const handleCheckbox = (e) => {
        const newCheckboxValue = e.currentTarget.checked;
        if (hasErrorOnSubmit && newCheckboxValue) {
            clearError();
        }
        updateCheckboxValue(newCheckboxValue);
    };
    useEffect(() => {
        if (hasErrorOnSubmit) {
            triggerPaymentSecurityAnalytics({ pageName: PAGE_NAME.START_ERROR });
        }
    }, [hasErrorOnSubmit]);
    return (_jsxs(_Fragment, { children: [_jsx(AgreementContainer, { hasError: hasErrorOnSubmit, children: _jsx(StyledCheckbox, { isChecked: isChecked, onChange: handleCheckbox, error: hasErrorOnSubmit ? ' ' : '', dataCy: "agreement-checkbox", dataReason: isChecked ? 'unselect' : 'select', dataObject: "checkbox", dataType: "payment security", dataAnalytics: "clicktrackingevent", icon: isChecked ? (_jsx(Icon, { icon: FAL_CHECK, color: colors.white, "aria-hidden": true, title: "check icon", size: "sm" })) : undefined, children: _jsx(TermsContainer, { children: _jsx(Trans, { i18nKey: "common.agreementCheck" }) }) }) }), hasErrorOnSubmit && (_jsxs(ErrorWrapper, { all: "xsmall", children: [_jsx(Icon, { title: "circle error icon", color: colors.terracotta, icon: FAR_CIRCLE_EXCLAMATION, size: "1x" }), _jsx(ErrorMessageText, { vertical: "small", children: t('errorMessages.termsAgreement') })] }))] }));
};
export default AgreementCheckbox;
